/* eslint-disable no-console */
/* eslint-disable */
import { DialogProgrammatic as Dialog } from 'buefy'

const consoleLogHeader = (s) => {
  console.log(`\n\n===== ${s} ====================\n`)
}

const consoleLogHeaderItem = (s) => {
  console.log(`-- ${s}\n`)
}
/* eslint-enable */

export const state = () => ({
  loading: [],
  env: process.env.DEV_ENV,
  windowHeight: window.innerHeight,
  windowWidth: window.innerWidth,
})

export const mutations = {
  reset(state) {
    state.loading = []
  },
  setWindowSize(state, w) {
    state.windowHeight = w.innerHeight
    state.windowWidth = w.innerWidth
  },
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
}

export const actions = {
  redirect(context, url) {
    try {
      consoleLogHeader(`redirecting in store to: ${url}`)

      this.$router.push({
        path: url,
      })
    } catch (error) {
      console.log('store: index.js: redirect: error', error)
    }
  },

  preloadFinancials(context, url) {
    context.dispatch('offers/getOffers')
    context.dispatch('contracts/getContracts')
    context.dispatch('entity/getSameAsEntities')
    context.dispatch('memberPayments/getStripeIssuingBalance')
    context.dispatch('memberPayments/getFuturePastPayments', {
      limit: 10,
      offset: 0,
    })
  },
}

export const getters = {
  loading(state) {
    return state.loading.length !== 0
  },
}
